module.exports = __webpack_public_path__ + "static/bounty-end-bb624be57912127fb2d108b43ea023ae.jpeg";